import { useSelector } from 'react-redux';

import { useFiltersContext } from '~/providers/FiltersProvider';
import { similarToImageFilterSelector } from '~/store/filters/selectors';

export const useAppliedFiltersCount = () => {
  const {
    filters: {
      customFields = {},
      modifiedDateEnd,
      modifiedDateStart,
      recordedDateStart,
      recordedDateEnd,
      uploadedDateStart,
      uploadedDateEnd,
      tds: takenDateStart,
      tde: takenDateEnd,
      camMake: cameraMake,
      camModel: cameraModel,
      similarTo,
      ...restFilters
    },
  } = useFiltersContext();
  const similarToImage = useSelector(similarToImageFilterSelector);
  const hasAppliedImageSearchFilter = !!similarToImage;

  let filtersCount = Object.keys(restFilters).length + Object.keys(customFields).length;

  if (modifiedDateEnd || modifiedDateStart) filtersCount += 1;
  if (recordedDateEnd || recordedDateStart) filtersCount += 1;
  if (uploadedDateEnd || uploadedDateStart) filtersCount += 1;
  if (takenDateStart || takenDateEnd) filtersCount += 1;
  if (hasAppliedImageSearchFilter) filtersCount += 1;
  if (similarTo) filtersCount += 1;
  if (cameraMake || cameraModel) filtersCount += 1;

  // image search filters are used exclusively and cannot be saved
  let filtersCannotBeSavedCount = 0;
  if (hasAppliedImageSearchFilter) filtersCannotBeSavedCount += 1;
  if (similarTo) filtersCannotBeSavedCount += 1;

  // Image search-related filters are used exclusively and cannot be saved
  const filtersCanBeSaved = !!filtersCount && filtersCannotBeSavedCount === 0;

  return { filtersCount, filtersCanBeSaved };
};
